import { BrowserRouter, Route, Routes } from "react-router-dom"
import { AuthProvider } from "./components/logincomponent/subcomponent/context/AuthProvider";
import RequireAuth from "./components/logincomponent/subcomponent/context/RequireAuth";
import unProtectedRoutes from "./Routes/unprotected";
import protectedRoutes from "./Routes/protected";
import 'aos/dist/aos.css';
import AOS from 'aos';
import { useEffect } from "react";
import AppWrapper from "./AppWrapper";

function App() {
  useEffect(() => {
    AOS.init();
  }, [])
  return (

    <BrowserRouter>
      <AuthProvider>
        <AppWrapper>
          <Routes>
            <Route element={<RequireAuth />}>
              {protectedRoutes?.map((el, i) => <Route key={el?.path || i} path={el?.path} element={el?.element} />)}
            </Route>
            {unProtectedRoutes?.map((el, i) => <Route key={el?.path || i} path={el?.path} element={el?.element} />)}
          </Routes>
        </AppWrapper>
      </AuthProvider>
    </BrowserRouter>
  );
}
export default App;
